// Personal tab fields

import { Item as I } from '../../../../services/itemUtils';
import { FIELDS as F } from '../../../../services/consumerFields';
import * as C from '../../../../services/marketConfig';

export function getFields(L, market) {
    const items1 = [
        I.new(L.consumerpage_personal_field_first_name, F.FIRST_NAME).build(),
        I.new(L.consumerpage_personal_field_last_name, F.LAST_NAME)
            .editable()
            .required(L.consumerpage_error_required)
            .build(),
        I.new(L.consumerpage_personal_field_dob, F.DATE_OF_BIRTH)
            .date(C.getMarketValue(C.MARKET_FORMAT_DATE, market))
            .build(),
        I.new(L.consumerpage_personal_field_gender, F.GENDER)
            .editable()
            .required(L.consumerpage_error_required)
            .dropdown(L.dict_gender)
            .build(),
        I.new(L.consumerpage_personal_field_email, F.EMAIL)
            .editableIf(
                C.getMarketValue(C.MARKET_FIELDS.email, market).editable
            )
            .requiredIf(
                C.getMarketValue(C.MARKET_FIELDS.email, market).required,
                L.consumerpage_error_required
            )
            .regexpValidator(
                C.getMarketValue(C.MARKET_REGEXP_EMAIL, market),
                L.consumerpage_error_email
            )
            .build(),
        I.new(L.consumerpage_personal_field_language, F.LANGUAGES)
            .editable()
            .required(L.consumerpage_error_required)
            .dropdown(L.dict_language, C.MARKET_VALUES_LANGUAGE[market])
            .build(),
        I.new(L.consumerpage_personal_field_home_country, F.COUNTRY_CODE)
            .dropdown(L.dict_country)
            .build(),
    ];

    const items2 = [
        I.new(L.consumerpage_personal_field_mobile_phone, F.MOBILE_NUMBER)
            .editable()
            .regexpValidator(
                C.getMarketValue(C.MARKET_REGEXP_MOBILE, market),
                L.consumerpage_error_phone
            )
            .build(),
        I.new(L.consumerpage_personal_field_home_phone, F.HOME_NUMBER).build(),

        I.new(
            L.consumerpage_personal_field_mobile_verification_status,
            F.MOBILE_VERIFICATION_STATUS
        )
            .dropdown(L.dict_mobile_status)
            .build(),
        I.new(
            L.consumerpage_personal_field_mobile_verification_date,
            F.MOBILE_VERIFICATION_DATE
        )
            .date(C.getMarketValue(C.MARKET_FORMAT_DATE, market))
            .build(),
    ];

    return [
        { id: 1, items: items1 },
        { id: 2, items: items2 },
    ];
}
